var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiamondBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24.0 21.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9947964,0 L0,14.2503729 L4.87893028,0 L11.9947964,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9633624,0 L7.11586609,6.28693758 L0,6.28693758 L4.9633624,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.15250369,0 L7.11586609,6.28693758 L0,6.28693758 L2.15250369,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87893028,0 L9.75786056,6.28693758 L0,6.28693758 L4.87893028,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03143397,0 L2.15250369,6.28693758 L0,0 L7.03143397,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03143397,0 L4.87893028,6.28693758 L0,0 L7.03143397,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75786056,0 L4.87893028,14.2503729 L0,0 L9.75786056,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11586609,0 L11.9947964,14.2503729 L0,0 L7.11586609,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-175.0 -498.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.0 85.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 402.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.0 11.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.1212121212121211)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.994796375101988 6.321312665828789)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 11.9947964,0 11.9947964,14.2503729 0,14.2503729 0,0",
    stroke: "none",
    fill: "#00B5E4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.034375087278312844)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.11586609,0 7.11586609,6.28693758 0,6.28693758 0,0",
    stroke: "none",
    fill: "#59E4F1"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.87372665534804 0.034375087278312844)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.11586609,0 7.11586609,6.28693758 0,6.28693758 0,0",
    stroke: "none",
    fill: "#61E1F0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.11586609485591 0.034375087278312844)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 9.75786056,0 9.75786056,6.28693758 0,6.28693758 0,0",
    stroke: "none",
    fill: "#B0F8FD"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.96336240160519 0.03437508727831329)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.03143397,0 7.03143397,6.28693758 0,6.28693758 0,0",
    stroke: "none",
    fill: "#71EFFB"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.99479637510197 0.03437508727831329)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.03143397,0 7.03143397,6.28693758 0,6.28693758 0,0",
    stroke: "none",
    fill: "#8AF1F8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.11586609485591 6.321312665828789)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 9.75786056,0 9.75786056,14.2503729 0,14.2503729 0,0",
    stroke: "none",
    fill: "#00D5F0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 6.321312665828789)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 11.9947964,0 11.9947964,14.2503729 0,14.2503729 0,0",
    stroke: "none",
    fill: "#00BBE4"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiamondBlue);
export default __webpack_public_path__ + "static/media/icDiamondBlue.6c47e212b0d44f9c61ec984d09e79c3f.svg";
export { ForwardRef as ReactComponent };